import React from 'react';
import Select from 'react-select';

// https://react-select.com/
// https://www.npmjs.com/package/react-select

const style = {
  control: (base, state) => ({
    ...base,
    minHeight: 31,
    height: 'auto',
    boxShadow: state.isFocused ? '0 0 0 2px rgb(24 144 255 / 20%)' : 0,
    borderColor: '#d9d9d9',
    padding: 0,
    borderRadius: 2,
    width: 110,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  input: () => ({ padding: 0, margin: 0 }),
  valueContainer: (base) => ({
    ...base,
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    overflow: 'hidden',
    height: 'auto',
    padding: '2px 8px',
  }),
  dropdownIndicator: () => ({
    display: 'flex',
    color: '#ccc',
    padding: '0 5px',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 10000,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 10000,
  }),
};

const DropdownSelect = ({
  name,
  onChange,
  value,
  options,
  styles: incomingStyles,
  ...props
}) => {
  // Merge caller-provided styles while enforcing high z-index on menu and portal
  const mergedStyles = { ...style, ...(incomingStyles || {}) };
  const enforcedMenu = mergedStyles.menu
    ? (base, state) => ({
        ...(typeof mergedStyles.menu === 'function'
          ? mergedStyles.menu(base, state)
          : mergedStyles.menu),
        zIndex: 100000,
      })
    : (base) => ({ ...base, zIndex: 100000 });
  const enforcedMenuPortal = mergedStyles.menuPortal
    ? (base) => ({
        ...(typeof mergedStyles.menuPortal === 'function'
          ? mergedStyles.menuPortal(base)
          : mergedStyles.menuPortal),
        zIndex: 100000,
      })
    : (base) => ({ ...base, zIndex: 100000 });

  const finalStyles = {
    ...mergedStyles,
    menu: enforcedMenu,
    menuPortal: enforcedMenuPortal,
  };

  return (
    <Select
      name={name}
      onChange={onChange}
      value={value}
      styles={finalStyles}
      options={options}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition="fixed"
      {...props}></Select>
  );
};

export default DropdownSelect;
